import { lazy } from 'react';
import { Navigate, createBrowserRouter } from 'react-router-dom';

import currentAccountRoutes from './currentAccount';
import productionRoutes from './production';
import quotationRoutes from './quotation';
import preliquidationRoutes from './preliquidation';
import sinisterRoutes from './sinister';
import emissionRoutes from './emission';
import userRoutes from './user'
import virtualOfficeRoutes from './virtualOffice'
    
const LoginPage = lazy(() => import('../pages').then(module => ({ default: module.LoginPage })));
const HomePage = lazy(() => import('../pages').then(module => ({ default: module.HomePage })));
const NotFoundPage = lazy(() => import('../pages').then(module => ({ default: module.NotFound })));
const LogoutPage = lazy(() => import('../pages').then(module => ({ default: module.LogoutPage })));
const IntermedaryPage = lazy(() => import('../pages').then(module => ({ default: module.IntermedaryPage })));
const PrivateWrapper = lazy(() => import('../shared/components').then(module => ({ default: module.PrivateWrapper })));

export const router = createBrowserRouter([
  //Public
  {
    path: '/login',
    element: <LoginPage title='Iniciar sesión' />,
  },
  //Private
  {
    path: '/',
    element: <PrivateWrapper />,
    errorElement: <NotFoundPage />,
    children: [
      {
        path: '/home',
        element: <HomePage title={'Home'} />,
      },
      {
        path: '/logout',
        element: <LogoutPage />,
      },
      {
        path: '/seleccionar-intermediario',
        element: <IntermedaryPage preserveIntermediary={false} title={'Selección de intermediarios'} />,
      },
      {
        path: '/seleccionar-intermediario-dependiente',
        element: <IntermedaryPage preserveIntermediary={true} title={'Intermediarios dependientes'} />,
      },
      productionRoutes,
      currentAccountRoutes,
      quotationRoutes,
      emissionRoutes,
      userRoutes,
      virtualOfficeRoutes,
      preliquidationRoutes,
      sinisterRoutes,
      {
        path: '',
        element: <Navigate to='/home' />,
      },
    ],
  },

  // Redirect to login if the user is not auth. 
  {
    path: '*',
    element: <PrivateWrapper children={ <NotFoundPage /> } />,
  }
], { basename: `${process.env.PUBLIC_URL}` });
